import api from './api';

const revShareService = {
    getVaultSummary: (vaultId) => api.get(`/rev-share/vault-summary?vaultId=${vaultId}`),
    getTransfers: (partnerId, from, to) => {
        const params = new URLSearchParams({ partnerId });
        if (from) params.append('from', from);
        if (to) params.append('to', to);
        return api.get(`/rev-share/transfers?${params.toString()}`);
    },

    getDefaultTiers: (product = 'vault') => api.get(`/rev-share/default?product=${product}`),
    createDefaultTier: (product, data) => api.post('/rev-share/default', { product, ...data }),
    updateDefaultTier: (id, data) => api.put(`/rev-share/default/${id}`, data),
    deleteDefaultTier: (id) => api.delete(`/rev-share/default/${id}`),

    getPartnerTiers: (partnerId, product = 'vault') => api.get(`/rev-share/partner?partnerId=${partnerId}&product=${product}`),
    createPartnerTier: (partnerId, product, data) => api.post('/rev-share/partner', { partnerId, product, ...data }),
    updatePartnerTier: (id, data) => api.put(`/rev-share/partner/${id}`, data),
    deletePartnerTier: (id) => api.delete(`/rev-share/partner/${id}`),
    copyDefaultToPartner: (partnerId, product = 'vault') => api.post('/rev-share/partner/copy-default', { partnerId, product }),
};

export default revShareService;
